import { MerchantFeature, isFeatureEnabled } from "domain/merchant";
import useActiveMerchant from "./useActiveMerchant";

export default function useMerchantFeature(feature: MerchantFeature): boolean {
    const merchant = useActiveMerchant();

    return isFeatureEnabled(merchant, feature);
}